module.exports = __webpack_public_path__ + "static/img/b08.c114129.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/b08.jpg
// module id = rYPQ
// module chunks = 1